var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-content",staticStyle:{"float":"none","margin":"auto"}},[_c('div',{staticClass:"home-wrapper-stop",attrs:{"id":"home-stop"}},[_c('user-header'),_vm._v(" "),_c('router-view')],1)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78bd8276","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/UserPage.vue
// module id = XD84
// module chunks = 0